// pi-admin uses JSON-only WAMP serialization (wamp.2.json). Throwing on init
// makes autobahn's try/catch in serializer.js fall through, so msgpack is never
// offered to the server and never used at runtime. Keeping this stub lets us
// drop the real msgpack5 (~70 KB minified) plus its transitive deps (safe-buffer,
// bl, readable-stream) and the corresponding buffer/stream/util/events polyfills.
//
// Authored as CommonJS (`.cjs`) so autobahn's `require('msgpack5')(opts)` call
// receives the function directly. An ESM default export would be wrapped as
// `{ default: fn }` by the CJS interop layer and fail with "is not a function".
module.exports = function msgpack5Stub() {
  throw new Error("msgpack5 stubbed: pi-admin uses JSON-only WAMP serialization");
};
